import { useState, useEffect, useCallback } from 'react';
import { api, MarketplaceCategory } from '../../lib/api';

interface UseCategoriesReturn {
  categories: MarketplaceCategory[];
  loading: boolean;
  error: string | null;
  refresh: () => void;
}

export function useCategories(): UseCategoriesReturn {
  const [categories, setCategories] = useState<MarketplaceCategory[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchCategories = useCallback(async () => {
    setLoading(true);
    setError(null);

    try {
      const result = await api.getMarketplaceCategories();
      setCategories(result.categories);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to load categories');
      setCategories([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchCategories();
  }, [fetchCategories]);

  return {
    categories,
    loading,
    error,
    refresh: fetchCategories,
  };
}
